import { useContext } from 'react'

import { Field, useFormikContext } from 'formik'
import { AppQuizUsageQuestionEssay } from 'globalTypes'

import CoverImage from 'Root/App/CoverImage'
import Textarea from 'Root/App/Form/Textarea'
import PageLinkWrapper from 'Root/App/Quiz/PageLinkWrapper'
import { Context as StateContext } from 'Root/App/Quiz/StateContext'
import Title from 'Root/App/Title'

interface Props {
  question: AppQuizUsageQuestionEssay
}

const Essay = ({ question }: Props) => {
  const {
    state: { content },
  } = useContext(StateContext)
  const { setFieldValue, setFieldTouched } = useFormikContext()

  const id = `answers.${question.id}`

  return (
    <div className="flex flex-col gap-y-3">
      <PageLinkWrapper slug={content.slug}>
        <Title>{question.title}</Title>
      </PageLinkWrapper>

      {Boolean(question.image) && <CoverImage imageUrl={question.image} />}

      <div className="flex flex-col gap-y-3">
        <Field
          as={Textarea}
          id={id}
          name={id}
          onChange={({ target }) => {
            setFieldValue(id, target.value)
            setFieldTouched(id, true)
          }}
        />
      </div>
    </div>
  )
}

export default Essay
